import {
  DollarOutlined,
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Avatar, Dropdown } from "antd";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import CommonBase from "../../../share/base/network/axiosNetwork";
import { reloadWallet } from "../../screen/login/redux/walletReducer";
import { formatCurrencyVND } from "../../../share/base/common/common";
function Topbar({ onToggle, userInfo, walletInfo, reloadWallet, history }) {
  useEffect(() => {
    if (userInfo?.username) {
      reloadWallet();
    }
  }, [userInfo?.username, reloadWallet]);

  const sigOut = () => {
    CommonBase.setLogOut();
  };
  const userMenuItem = [
    {
      key: "profile",
      icon: <UserOutlined />,
      label: "Thông tin cá nhân",
    },
    {
      key: "settings",
      icon: <SettingOutlined />,
      label: "Cài đặt tài khoản",
    },
    { type: "divider" },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Đăng xuất",
      danger: true,
    },
  ];

  const handleUserMenuClick = ({ key }) => {
    if (key === "logout") {
      sigOut();
    } else if (key === "profile") {
      history.push("/profile");
    } else if (key === "settings") {
      history.push("/profile");
    }
  };

  console.log("walletInfo", walletInfo);

  return (
    <nav className="app-header navbar navbar-expand bg-body">
      {/*Container*/}
      <div className="container-fluid">
        {/*Start Navbar Links*/}
        <ul className="navbar-nav">
          <li className="nav-item" onClick={onToggle}>
            <a
              className="nav-link"
              data-lte-toggle="sidebar"
              href="#"
              role="button"
            >
              <i className="bi bi-list"></i>
            </a>
          </li>
        </ul>
        {/*Start Navbar Links*/}
        {/*End Navbar Links*/}
        <ul className="navbar-nav ms-auto">
          {/*Navbar Search*/}

          {/*Navbar Search*/}
          {/*Messages Dropdown Menu*/}

          {/*Messages Dropdown Menu*/}
          {/*Notifications Dropdown Menu*/}
          {/* <li className="nav-item dropdown">
            <a className="nav-link" data-bs-toggle="dropdown" href="#">
              <i className="bi bi-bell-fill"></i>
              <span className="navbar-badge badge text-bg-warning">15</span>
            </a>
            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end">
              <span className="dropdown-item dropdown-header">
                15 Notifications
              </span>
              <div className="dropdown-divider"></div>
              <a href="#" className="dropdown-item">
                <i className="bi bi-envelope me-2"></i> 4 new messages
                <span className="float-end text-secondary fs-7">3 mins</span>
              </a>
              <div className="dropdown-divider"></div>
              <a href="#" className="dropdown-item">
                <i className="bi bi-people-fill me-2"></i> 8 friend requests
                <span className="float-end text-secondary fs-7">12 hours</span>
              </a>
              <div className="dropdown-divider"></div>
              <a href="#" className="dropdown-item">
                <i className="bi bi-file-earmark-fill me-2"></i> 3 new reports
                <span className="float-end text-secondary fs-7">2 days</span>
              </a>
              <div className="dropdown-divider"></div>
              <a href="#" className="dropdown-item dropdown-footer">
                {" "}
                See All Notifications{" "}
              </a>
            </div>
          </li> */}
          {/*Notifications Dropdown Menu*/}
          {/*Fullscreen Toggle*/}
          {/* <li className="nav-item">
            <a className="nav-link" href="#" data-lte-toggle="fullscreen">
              <i
                data-lte-icon="maximize"
                className="bi bi-arrows-fullscreen"
              ></i>
              <i
                data-lte-icon="minimize"
                className="bi bi-fullscreen-exit"
                style={{ display: "none" }}
              ></i>
            </a>
          </li> */}
          {/*Fullscreen Toggle*/}

          {/* Wallet Section */}
          <li className="nav-item ">
            <a className="nav-link">
              <DollarOutlined
                className="me-2"
                style={{ fontSize: "20px", color: "#707b85ff" }}
              />
              <span
                className="fw-bolder"
                style={{
                  color: "#262626",
                  fontSize: "15px",
                  letterSpacing: "0.5px",
                }}
              >
                {walletInfo?.balance
                  ? formatCurrencyVND(walletInfo.balance)
                  : 0}
              </span>
            </a>
          </li>
          {/* Wallet Section */}

          {/* User Avatar */}
          <Dropdown
            menu={{ items: userMenuItem, onClick: handleUserMenuClick }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <div className="d-flex align-items-center cursor-pointer p-1">
              <Avatar
                size={40}
                src={userInfo?.avatar || "/assets/img/userlogin.jpg"}
                className="border-2 border-neutral-200"
              />
              <span className="ms-2 fw-semibold text-dark d-none d-md-block">
                {userInfo?.username}
              </span>
            </div>
          </Dropdown>
        </ul>
        {/*End Navbar Links*/}
      </div>
      {/*Container*/}
    </nav>
  );
}
const mapStateToProps = (state) => {
  let { userInfo } = state.loginReducer.toJS();
  let { walletInfo } = state.walletReducer.toJS();
  return {
    userInfo: userInfo?.userInfo,
    walletInfo: walletInfo,
  };
};

const mapDispatchToProps = {
  reloadWallet,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Topbar));
